<template>
  <div class="main-chapter1">
    <n-loader :loading="$var('load')" />
    <div class="right-info">
      РДС РК 1.03-05-2011<br>
      Приложение Р<br>
      (обязательное)
    </div>
    <div class="chapter-title">Форма: Журнала индивидуальных испытаний электропроводов совместно с механизмами</div>
    <div class="chapter-title">ЖУРНАЛ <br> индивидуальных испытаний электроприводов совместно с механизмами</div>
    <n-items v-if="project">
      <n-input title="Заказчик" v-bind="$form.input('customer')" :text="!editable" />
      <n-input title="Объект (наименование, район объекта)" v-bind="$form.input('object')"  :text="!editable"/>
      <div class="chapter-title">Для организации индивидуальных испытаний электроприводов совместно с механизмами выделяются следующие работники:</div>
      <n-input title="от заказчика: (занимаемая должность, Ф.И.О., подпись)" v-bind="$form.input('fromCus')" :text="!editable" />
      <n-input title="от  электромонтажной организации:  (наименование организации, должность, ф. И. О., подпись)" v-bind="$form.input('fromElec1')" :text="!editable" />
      <n-input title="от пусконаладочной организации:  (наименование организации, должность, Ф.И.О., группа по электробезопасности, подпись)" v-bind="$form.input('fromPush')" :text="!editable" />
      <n-input title="от электромонтажной организации: (наименование организации должность, Ф.И.О., группа по электробезопасности, подпись)" v-bind="$form.input('fromElec2')" :text="!editable" />
      <n-input title="от механомонтажной организации:  (наименование организации, должность, ф. и. о., подпись)" v-bind="$form.input('fromMech')" :text="!editable" />
      <n-button v-if="editable" color="success" @click="submit">Сохранить</n-button>
    </n-items>
  </div>
</template>

<script>
export default {
  name: 'MainChapter1',
  props: {
    project: { type: Object, default: () => ({}), },
    journal: { type: Object, default: () => ({}), },
    editable: { type: Boolean, default: false, },
  },
  data: () => ({
  }),
  created() {
    this.$form.init(this.journal.data)
  },
  methods: {
    submit() {
      this.$var('load', true)
      $api.journals.edit(this.project.id, this.journal.name, this.$form.get()).then(() => {
        this.$emit('reload')
      }).finally(() => {
        this.$var('load', false)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
  .main-chapter1 {
  
  }
</style>
